import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
    state: {
        calls: [],
    },
    getters: {
        calls: (state) => state.calls,
    },
    mutations: {
        setCalls: (state, data) => {
            state.calls = data;
        },
    },
    actions: {
        getCalls: async ({ commit, dispatch }, id) => {
            try {
                const response = await api({ requiresAuth: true }).get(
                    `v1/customer-calls/${id}`
                );
                const { data } = response.data;
                commit("setCalls", data);
                return data;
            } catch (error) {
                dispatch("showToast", {
                    type: "error",
                    message: error.response?.data?.message || t("messages.failedToLoadCalls")
                });
                throw error;
            }
        },

        createCalls: async (
            { dispatch },
            {
                agent_id,
                customer_id,
                call_category_id,
                date,
                time,
                description,
                duration_minutes,
            }
        ) => {
            try {
                const response = await api({ requiresAuth: true }).post("v1/calls", {
                    agent_id,
                    customer_id,
                    call_category_id,
                    date,
                    time,
                    description,
                    duration_minutes,
                });

                const newCall = response.data.data;
                const callId = newCall.id;

                await dispatch("getCalls", customer_id);

                dispatch("showToast", {
                    type: "success",
                    message: response.data.message || t("messages.callCreatedSuccessfully")
                });

                return callId;
            } catch (error) {
                dispatch("showToast", {
                    type: "error",
                    message: error.response?.data?.message || t("messages.failedToCreateCall")
                });
                throw error;
            }
        },

        deleteCalls: async ({ dispatch }, { callId, customerId }) => {
            try {
                const response = await api({ requiresAuth: true }).delete(
                    `v1/calls/${callId}`
                );
                await dispatch("getCalls", customerId);

                dispatch("showToast", {
                    type: "success",
                    message: response.data.message || t("messages.callDeletedSuccessfully")
                });
            } catch (error) {
                dispatch("showToast", {
                    type: "error",
                    message: error.response?.data?.message || t("messages.failedToDeleteCall")
                });
                throw error;
            }
        },

        updateCalls: async (
            { dispatch },
            {
                id,
                agent_id,
                customer_id,
                call_category_id,
                date,
                time,
                description,
                duration_minutes
            }
        ) => {
            try {
                const response = await api({ requiresAuth: true }).patch(
                    `v1/calls/${id}`, {
                    agent_id,
                    customer_id,
                    call_category_id,
                    date,
                    time,
                    description,
                    duration_minutes
                }
                );
                await dispatch("getCalls", customer_id);

                dispatch("showToast", {
                    type: "success",
                    message: response.data.message || t("messages.callUpdatedSuccessfully")
                });
            } catch (error) {
                dispatch("showToast", {
                    type: "error",
                    message: error.response?.data?.message || t("messages.failedToUpdateCall")
                });
                throw error;
            }
        },

        addCallsFile: async ({ dispatch }, { callId, files }) => {
            try {
                const formData = new FormData();

                files.forEach((file) => {
                    formData.append("call_files[]", file);
                });
                const response = await api({ requiresAuth: true }).post(
                    `v1/calls/${callId}/files`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    }
                );

                dispatch("showToast", {
                    type: "success",
                    message: response.data.message || t("messages.filesUploadedSuccessfully")
                });
            } catch (error) {
                dispatch("showToast", {
                    type: "error",
                    message: error.response?.data?.message || t("messages.failedToUploadFile")
                });
                throw error;
            }
        },

        fetchCallsFiles: async ({ commit, dispatch }, callId) => {
            try {
                const response = await api({ requiresAuth: true }).get(
                    `/v1/calls/${callId}`
                );
                const { data } = response.data;
                commit("setFilesToEdit", data.files, { root: true });
                return data;
            } catch (error) {
                dispatch("showToast", {
                    type: "error",
                    message: error.response?.data?.message || t("messages.failedToLoadCallFiles")
                });
                throw error;
            }
        },
    }
}
